/**
 * Defines a Popper modifier that will set Popper's z-index based on the value
 * of `pvdZIndex`.
 */
function getZIndexPopperModifier() {
    var _this = this;
    return {
        name: 'zIndex',
        enabled: true,
        phase: 'beforeWrite',
        fn: function (modifier) {
            modifier.state.styles.popper['z-index'] = _this.pvdZIndex;
        },
    };
}

export { getZIndexPopperModifier };
